import type { PageProps } from 'gatsby';
import React from 'react';

import CompleteNewPassword from '@views/Authentication/CompleteNewPassword/EmailForm';

function CompleteNewPasswordPage({ params }: PageProps) {
  return <CompleteNewPassword {...params} />;
}

export default CompleteNewPasswordPage;
